const BiographyBookMainData = [
    {
        book_id: 9467,
        author: "김만규",
        title: "학도병아 잘 싸웠다!",
        publisher: "기독신보출판국",
        year: 2010,
        image: "biography_image_1.jpg"
    },
    {
        book_id: 7575,
        author: "김방한",
        title: "한 언어학자의 회상",
        publisher: "민음사",
        year: 1996,
        image: "biography_image_2.jpg"
    },
    {
        book_id: 6876,
        author: "김성칠",
        title: "역사 앞에서 : 한 사학자의 6·25 일기",
        publisher: "창작과비평사",
        year: 1993,
        image: "biography_image_3.jpg"
    },
    {
        book_id: 7734,
        author: "김영삼",
        title: "김영삼 회고록 1 (개정판). 민주주의를 위한 나의 투쟁",
        publisher: "백산서당",
        year: 2015,
        image: "biography_image_4.jpg"
    },
    {
        book_id: 6989,
        author: "이영기;이대우;최승호 편",
        title: "그날을 어찌 잊을 수가 있겠습니까 : 경산 코발트광산 구술 증언집 1",
        publisher: "학이사",
        year: 2023,
        image: "biography_image_5.jpg"
    },
    {
        book_id: 7838,
        author: "김중종;한국역사연구회 현대사증언반 편",
        title: "끝나지 않은 여정 - 한국현대사 증언록 1",
        publisher: "도서출판 대동",
        year: 1996,
        image: "biography_image_6.jpg"
    },
    {
        book_id: 9798,
        author: "롯데지주",
        title: "열정은 잠들지 않는다 : 한계를 넘어 더 큰 내일로 : 롯데그룹 창업주 신격호 회고록",
        publisher: "나남",
        year: 2021,
        image: "biography_image_7.jpg"
    },
    {
        book_id: 7079,
        author: "민종기",
        title: "나를 태워 쇠를 녹이다 : 케이티롤 민종기 회장의 나의 삶 나의 길",
        publisher: "리음북스;에듀뮤직",
        year: 2016,
        image: "biography_image_8.jpg"
    },
    {
        book_id: 7295,
        author: "박한식",
        title: "평화에 미치다 : 박한식 회고록",
        publisher: "삼인",
        year: 2021,
        image: "biography_image_9.jpg"
    },
    {
        book_id: 9375,
        author: "송남헌",
        title: "김규식과 함께 한 길 - 민족의 자주와 통일을 위하여",
        publisher: "한울",
        year: 2000,
        image: "biography_image_10.jpg"
    },
    {
        book_id: 10189,
        author: "안병훈",
        title: "그래도 나는 또 꿈을 꾼다 : 안병훈 회고록",
        publisher: "기파랑",
        year: 2017,
        image: "biography_image_11.jpg"
    },
    {
        book_id: 9663,
        author: "유종호",
        title: "나의 해방 전후 (1940-1949)",
        publisher: "민음사",
        year: 2004,
        image: "biography_image_12.jpg"
    },
    {
        book_id: 7859,
        author: "이병철",
        title: "호암자전 : 삼성 창업자 호암 이병철 자서전",
        publisher: "나남",
        year: 2014,
        image: "biography_image_13.jpg"
    },
    {
        book_id: 9972,
        author: "이태섭",
        title: "(가난을 넘어, 죽음을 넘어) 나의 인생, 나의 도전",
        publisher: "서영",
        year: 2015,
        image: "biography_image_14.jpg"
    },
    {
        book_id: 9250,
        author: "정몽준",
        title: "나의 도전 나의 열정 : 정몽준의 인생과 세상 이야기",
        publisher: "김영사",
        year: 2011,
        image: "biography_image_15.jpg"
    },
    {
        book_id: 7815,
        author: "김수환",
        title: "추기경 김수환 이야기",
        publisher: "평화방송·평화신문",
        year: 2005,
        image: "biography_image_16.jpg"
    },
    {
        book_id: 8298,
        author: "하정웅",
        title: "나의 두 조국",
        publisher: "마·주翰",
        year: 2002,
        image: "biography_image_17.jpg"
    },
    {
        book_id: 10096,
        author: "황장엽",
        title: "나는 역사의 진리를 보았다 : 황장엽 회고록",
        publisher: "한울",
        year: 1999,
        image: "biography_image_18.jpg"
    },
    {
        book_id: 8514,
        author: "이희호",
        title: "동행 : 고난과 영광의 회전무대 : 이희호 자서전",
        publisher: "웅진씽크빅",
        year: 2008,
        image: "biography_image_19.jpg"
    },
    {
        book_id: 9677,
        author: "문동환",
        title: "문동환 자서전 : 떠돌이 목자의 노래",
        publisher: "삼인",
        year: 2009,
        image: "biography_image_20.jpg"
    },
    {
        book_id: 8740,
        author: "정수일",
        title: "시대인, 소명에 따르다 : 정수일 회고록",
        publisher: "북이십일 아르테",
        year: 2022,
        image: "biography_image_21.jpg"
    },
    {
        book_id: 7087,
        author: "이길여",
        title: "길을 묻다 : 이길여 회고록",
        publisher: "샘터사",
        year: 2022,
        image: "biography_image_22.jpg"
    },
    {
        book_id: 8145,
        author: "김활란",
        title: "그 빛속의 작은 生命 : 又月 金活蘭 自敍傳",
        publisher: "梨花女子大學校出版部",
        year: 1983,
        image: "biography_image_23.jpg"
    },
    {
        book_id: 7269,
        author: "김동순",
        title: "정신과 의사로 살아온 한 여성의 길 : 善齋 김동순 선생 회고록",
        publisher: "학지사",
        year: 2017,
        image: "biography_image_24.jpg"
    },
    {
        book_id: 8773,
        author: "함석헌",
        title: "함석헌 자전적 인생론",
        publisher: "정우사",
        year: 2003,
        image: "biography_image_25.jpg"
    },
    {
        book_id: 8792,
        author: "함진옥",
        title: "젊음이 온다면 다시 이길을",
        publisher: "大光文化社",
        year: 1985,
        image: "biography_image_26.jpg"
    },
    {
        book_id: 8087,
        author: "이태영",
        title: "나의 만남 나의 인생",
        publisher: "正宇社",
        year: 1991,
        image: "biography_image_27.jpg"
    },
    {
        book_id: 9651,
        author: "유진오",
        title: "양호기 : 보전·고대삼십오년의 회고",
        publisher: "고대출판부",
        year: 1983,
        image: "biography_image_28.jpg"
    },
    {
        book_id: 9480,
        author: "오천석",
        title: "외로운 城主",
        publisher: "교육과학사",
        year: 2001,
        image: "biography_image_29.jpg"
    },
]

export default BiographyBookMainData;